'use client';

import { Dialog, DialogBackdrop, DialogPanel, DialogTitle, TransitionChild } from '@headlessui/react';
import { IconX } from '@tabler/icons-react';

const BDrawer = ({ open, setOpen, children }) => {
  return (
    <Dialog open={open} onClose={setOpen} className="relative z-50">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity duration-500 ease-in-out data-closed:opacity-0"
      />

      <div className="fixed inset-0 overflow-hidden">
        <div className="absolute inset-0 overflow-hidden">
          <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
            <DialogPanel
              transition
              className="pointer-events-auto relative w-screen max-w-md transform transition duration-500 ease-in-out data-closed:translate-x-full"
            >
              <TransitionChild>
                <div className="absolute top-0 left-0 z-50 -ml-8 flex pt-4 pr-2 duration-500 ease-in-out data-closed:opacity-0">
                  <button
                    type="button"
                    onClick={() => setOpen(false)}
                    className="relative rounded-md text-gray-300 hover:text-white focus:ring-2 focus:ring-white focus:outline-hidden"
                  >
                    <span className="absolute -inset-2.5" />
                    <span className="sr-only">fermer</span>
                    <IconX aria-hidden="true" className="size-6" />
                  </button>
                </div>
              </TransitionChild>
              <div className="flex h-full flex-col gap-8 overflow-y-scroll bg-white p-8 shadow-xl">{children}</div>
            </DialogPanel>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

const Header = ({ children }) => {
  return <DialogTitle>{children}</DialogTitle>;
};
const Body = ({ children }) => {
  return <>{children}</>;
};
BDrawer.Header = Header;
BDrawer.Body = Body;
export default BDrawer;
